// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/insurance-payment-report/insurance-payment-report.less
// module id = 3912
// module chunks = 0